export default {
    clearFilters: (state) => {
        state.queryParams = null;
        state.data = {};
        state.status = null;
        state.error = null;
    }
}; 